import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

const Toasts = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
};

export default Toasts;
